"use client";

import { useEffect } from "react";
import LogRocket from "logrocket";

import { env } from "~/env";

// TODO: Move this to env
const LOGROCKET_ID = "vhoh18/codemod-app";

export function Analytics() {
  useEffect(() => {
    if (env.NODE_ENV === "production") {
      LogRocket.init(LOGROCKET_ID);
    }
  }, []);

  return null;
}
